import React from 'react';
import { AdmissionAnswerText } from '@Pages/ClassRooms/Pages/SingleClassroom/Components/Admissons/AdmissionQuestions/AdmissionQuestions.styled';

export const QuestionAnswerText = (
	<AdmissionAnswerText>Answer</AdmissionAnswerText>
);

export default QuestionAnswerText;
